import { render, staticRenderFns } from "./coMarketItem.vue?vue&type=template&id=3df0662f&scoped=true&"
import script from "./coMarketItem.vue?vue&type=script&lang=ts&"
export * from "./coMarketItem.vue?vue&type=script&lang=ts&"
import style0 from "./coMarketItem.vue?vue&type=style&index=0&id=3df0662f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df0662f",
  null
  
)

export default component.exports